const SidebarButton = ({ active, onClick, icon, text, textColor = '#000', borderColor = 'gray-300' }) => {
    return (
        <button 
            className={`flex items-center w-full gap-2 py-2 px-4 rounded-2xl border border-${borderColor} ${active ? 'bg-[#BA7373] text-[#FFF]' : 'bg-white'}`} 
            onClick={onClick}>
            {icon} {text}
        </button>
    );
};

export default SidebarButton